import { type NexusApiActionDef } from "./action-def.types";
import { arr, obj } from "./output-format.builders";

export const emulatorActions: NexusApiActionDef[] = [
  {
    action: "emulator.createSession",
    label: "Create Session",
    description: "Create an emulator test session",
    inputSchema: {
      deploymentId: { type: "string", description: "Deployment ID" }
    },
    outputFormat: obj("Session details")
  },
  {
    action: "emulator.listSessions",
    label: "List Sessions",
    description: "List emulator sessions for a deployment",
    inputSchema: {
      deploymentId: { type: "string", description: "Deployment ID" }
    },
    outputFormat: arr("Sessions")
  },
  {
    action: "emulator.sendMessage",
    label: "Send Message",
    description: "Send a message in an emulator session",
    inputSchema: {
      deploymentId: { type: "string", description: "Deployment ID" },
      sessionId: { type: "string", description: "Session ID" },
      content: { type: "string", description: "Message content" },
      participantId: { type: "string", description: "Participant ID (optional)" }
    },
    outputFormat: obj("Send result")
  }
];
